// Date helpers for form defaults and comparisons. The server returns DATE columns
// as plain 'YYYY-MM-DD' strings (mysql2 `dateStrings`), so the client stays on
// strings too and never round-trips through a Date object.

// Today as 'YYYY-MM-DD' in the browser's local time. Built from local parts on
// purpose — `toISOString()` returns the UTC day, which is still yesterday during
// the first hours of an Israeli morning.
export const todayStr = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// Shift a 'YYYY-MM-DD' date by n days (n may be negative). UTC midnight on both sides,
// so no timezone or DST offset can turn a whole number of days into a different day.
//
// For ENTRY only — the "follow up in 7 days" buttons on the task form compute the date
// they write into the field. It is never used to judge whether a date has arrived: that
// is one rule and it lives on the server (calculations/dueTasks).
export const addDays = (dateStr, days) => {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + days);
  const pad = (n) => String(n).padStart(2, '0');
  return `${dt.getUTCFullYear()}-${pad(dt.getUTCMonth() + 1)}-${pad(dt.getUTCDate())}`;
};

// The current month as 'YYYY-MM' — the same local-time reasoning as todayStr.

export const currentMonthStr = () => todayStr().slice(0, 7);

// Shift a 'YYYY-MM' string by n months (n may be negative). String arithmetic, so
// there is no Date object and no timezone to drift.
export const addMonths = (monthStr, n) => {
  const [y, m] = monthStr.split('-').map(Number);
  const total = y * 12 + (m - 1) + n;
  return `${Math.floor(total / 12)}-${String((total % 12) + 1).padStart(2, '0')}`;
};
